import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import {
    PageListComponent, HeaderListComponent,
} from "../../common/component/Index";
import Wrapper from '../../common/component/Wrapper';
import RatingList from './RatingList';
import { get } from 'lodash';

let permissionActions = [];
export default class Ratings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {}
        };
        this.ratingListRef = React.createRef();
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATING);
        this.props.getListRatings();
    }

    render() {
        const { t, ratingState } = this.props;
        const { isFetching, approvingId, totalCount, totalPage, pageIndex, pageSize, ratings } = ratingState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'ratings'}
                        titleHeader={t('navigation.ratings')}
                    />
                    <RatingList ref={this.ratingListRef}
                        loading={isFetching}
                        approvingId={approvingId}
                        permissions={permissionActions}
                        ratings={ratings}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onApproveRating={this.onApproveRating}
                        onDeleteRating={this.onDeleteRating}
                        onApproveReply={this.onApproveReply}
                        onDeleteReply={this.onDeleteReply}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.props.getListRatings(newFilters);
        this.setState({ filters: newFilters })
        this.collapseAllRow();
    };

    onDeleteRating = (rating) => {
        this.props.deleteRating(rating, this.state.filters)
    }

    onApproveRating = (rating) => {
        this.props.approveRating(rating)
    }

    onDeleteReply = (reply) => {
        this.props.deleteRatingReply(reply, this.state.filters)
    }

    onApproveReply = (reply) => {
        this.props.approveRatingReply(reply)
    }

    getListRatings = () => {
        this.props.getListRatings()
    }

    collapseAllRow = () => {
        if (this.ratingListRef && this.ratingListRef.current && this.ratingListRef.current.collapseAllRow) {
            this.ratingListRef.current.collapseAllRow();
        }
    }

}

Ratings.defaultProps = {

}
